import Model from 'flarum/common/Model';
export default class Rank extends Model {
  points() {
    return Model.attribute('points').call(this);
  }
  name() {
    return Model.attribute('name').call(this);
  }
  color() {
    return Model.attribute('color').call(this);
  }
}
flarum.reg.add('fof-gamification', 'common/models/Rank', Rank);